module.exports = __webpack_public_path__ + "img/ueber-mich-1_640.a12cc927.jpg";